import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../home-new/tokens'
import Reveal from '../home-new/Reveal'

// Section 2 — "SHIPPOP BUSINESS รองรับธุรกิจทุกรูปแบบ": three white cards,
// each a PNG type icon + brand-blue title + muted desc + a dark pill link
// button. Mirrors the /new card rhythm (radius, shadow, spacing).

const cards = [
  {
    id: 'corporate',
    icon: '/static/img/home-business/types/corporate.png',
    href: '#benefits',
  },
  {
    id: 'online',
    icon: '/static/img/home-business/types/online.png',
    href: '#connect',
  },
  {
    id: 'marketplace',
    icon: '/static/img/home-business/types/marketplace.png',
    href: '#connect',
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: {
      padding: '44px 0',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 44px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      margin: '0 0 28px',
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '28px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '18px',
    },
  },
  card: {
    background: T.color.surface,
    borderRadius: 24,
    boxShadow: T.shadow.card,
    padding: '40px 28px 32px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 16px 36px rgba(0,102,204,0.14)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '32px 22px 26px',
    },
  },
  // Icons enlarged to the mockup's drawn size (business.png: icon renders
  // ~120-123px tall, up to ~151px wide). Previously 104px — read as too small
  // against the mockup.
  iconWrap: {
    height: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    '& img': {
      maxHeight: 120,
      maxWidth: 150,
      objectFit: 'contain',
    },
  },
  // Title enlarged to the mockup's drawn card-title cap-height (~23-24px).
  cardTitle: {
    fontFamily: T.font.heading,
    fontSize: 24,
    fontWeight: 600,
    color: T.color.brand,
    margin: '0 0 12px',
    minHeight: 60,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
      minHeight: 'auto',
    },
  },
  cardDesc: {
    fontFamily: T.font.body,
    fontSize: 15,
    color: T.color.muted,
    lineHeight: 1.7,
    margin: '0 0 26px',
    flexGrow: 1,
  },
  cardBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    padding: '0 26px',
    borderRadius: T.radius.pill,
    background: T.color.ink,
    color: T.color.onBrand,
    fontFamily: T.font.heading,
    fontSize: 15,
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'transform 0.2s ease, background 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      background: T.color.brandDeep,
      color: T.color.onBrand,
    },
  },
}))

const BusinessTypesBiz = () => {
  const classes = useStyles()
  const { t } = useTranslation('business')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            <span>SHIPPOP BUSINESS</span> {t('types.headingRest')}
          </h2>
        </Reveal>
        <div className={classes.grid}>
          {cards.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.12}>
              <div className={classes.card}>
                <span className={classes.iconWrap}>
                  <img src={c.icon} alt="" aria-hidden="true" loading="lazy" />
                </span>
                <h3 className={classes.cardTitle}>{t(`types.items.${c.id}.title`)}</h3>
                <p className={classes.cardDesc}>{t(`types.items.${c.id}.desc`)}</p>
                <a href={c.href} className={classes.cardBtn}>
                  {t(`types.items.${c.id}.cta`)}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default BusinessTypesBiz
